module.exports = require("awscred");